/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as TranscriptsTranscriptIdRouteImport } from './routes/transcripts/$transcriptId'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as DashboardUserRouteImport } from './routes/dashboard/user'
import { Route as DashboardChangelogRouteImport } from './routes/dashboard/changelog'
import { Route as DashboardAdminRouteImport } from './routes/dashboard/admin'
import { Route as DashboardCheckoutIndexRouteImport } from './routes/dashboard/checkout/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/dashboard/admin/index'
import { Route as DashboardTeamsTenantIdRouteImport } from './routes/dashboard/teams/$tenantId'
import { Route as DashboardGuildsApplicationGuildIdRouteImport } from './routes/dashboard/guilds/$applicationGuildId'
import { Route as DashboardCheckoutReturnRouteImport } from './routes/dashboard/checkout/return'
import { Route as DashboardApplicationsApplicationIdRouteImport } from './routes/dashboard/applications/$applicationId'
import { Route as DashboardAdminUsersRouteImport } from './routes/dashboard/admin/users'
import { Route as DashboardAdminTemplatesRouteImport } from './routes/dashboard/admin/templates'
import { Route as DashboardAdminOfficialPresetsRouteImport } from './routes/dashboard/admin/official-presets'
import { Route as DashboardAdminNotificationsRouteImport } from './routes/dashboard/admin/notifications'
import { Route as DashboardAdminCustomBotsRouteImport } from './routes/dashboard/admin/custom-bots'
import { Route as DashboardGuildsApplicationGuildIdIndexRouteImport } from './routes/dashboard/guilds/$applicationGuildId/index'
import { Route as DashboardAdminUsersIndexRouteImport } from './routes/dashboard/admin/users/index'
import { Route as DashboardAdminTemplatesIndexRouteImport } from './routes/dashboard/admin/templates/index'
import { Route as DashboardAdminCustomBotsIndexRouteImport } from './routes/dashboard/admin/custom-bots/index'
import { Route as DashboardGuildsApplicationGuildIdThreadsQaRouteImport } from './routes/dashboard/guilds/$applicationGuildId/threads-qa'
import { Route as DashboardGuildsApplicationGuildIdPermissionsRouteImport } from './routes/dashboard/guilds/$applicationGuildId/permissions'
import { Route as DashboardGuildsApplicationGuildIdKnowledgeBaseRouteImport } from './routes/dashboard/guilds/$applicationGuildId/knowledge-base'
import { Route as DashboardAdminUsersUserIdRouteImport } from './routes/dashboard/admin/users/$userId'
import { Route as DashboardAdminCustomBotsApplicationIdRouteImport } from './routes/dashboard/admin/custom-bots/$applicationId'
import { Route as DashboardGuildsApplicationGuildIdTicketsIndexRouteImport } from './routes/dashboard/guilds/$applicationGuildId/tickets/index'
import { Route as DashboardGuildsApplicationGuildIdTicketsTicketIdRouteImport } from './routes/dashboard/guilds/$applicationGuildId/tickets/$ticketId'

const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const TranscriptsTranscriptIdRoute = TranscriptsTranscriptIdRouteImport.update({
  id: '/transcripts/$transcriptId',
  path: '/transcripts/$transcriptId',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUserRoute = DashboardUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardChangelogRoute = DashboardChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminRoute = DashboardAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCheckoutIndexRoute = DashboardCheckoutIndexRouteImport.update({
  id: '/checkout/',
  path: '/checkout/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAdminRoute,
} as any)
const DashboardTeamsTenantIdRoute = DashboardTeamsTenantIdRouteImport.update({
  id: '/teams/$tenantId',
  path: '/teams/$tenantId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardGuildsApplicationGuildIdRoute =
  DashboardGuildsApplicationGuildIdRouteImport.update({
    id: '/guilds/$applicationGuildId',
    path: '/guilds/$applicationGuildId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCheckoutReturnRoute = DashboardCheckoutReturnRouteImport.update({
  id: '/checkout/return',
  path: '/checkout/return',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardApplicationsApplicationIdRoute =
  DashboardApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminUsersRoute = DashboardAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardAdminRoute,
} as any)
const DashboardAdminTemplatesRoute = DashboardAdminTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => DashboardAdminRoute,
} as any)
const DashboardAdminOfficialPresetsRoute =
  DashboardAdminOfficialPresetsRouteImport.update({
    id: '/official-presets',
    path: '/official-presets',
    getParentRoute: () => DashboardAdminRoute,
  } as any)
const DashboardAdminNotificationsRoute =
  DashboardAdminNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardAdminRoute,
  } as any)
const DashboardAdminCustomBotsRoute =
  DashboardAdminCustomBotsRouteImport.update({
    id: '/custom-bots',
    path: '/custom-bots',
    getParentRoute: () => DashboardAdminRoute,
  } as any)
const DashboardGuildsApplicationGuildIdIndexRoute =
  DashboardGuildsApplicationGuildIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardGuildsApplicationGuildIdRoute,
  } as any)
const DashboardAdminUsersIndexRoute =
  DashboardAdminUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAdminUsersRoute,
  } as any)
const DashboardAdminTemplatesIndexRoute =
  DashboardAdminTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAdminTemplatesRoute,
  } as any)
const DashboardAdminCustomBotsIndexRoute =
  DashboardAdminCustomBotsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAdminCustomBotsRoute,
  } as any)
const DashboardGuildsApplicationGuildIdThreadsQaRoute =
  DashboardGuildsApplicationGuildIdThreadsQaRouteImport.update({
    id: '/threads-qa',
    path: '/threads-qa',
    getParentRoute: () => DashboardGuildsApplicationGuildIdRoute,
  } as any)
const DashboardGuildsApplicationGuildIdPermissionsRoute =
  DashboardGuildsApplicationGuildIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => DashboardGuildsApplicationGuildIdRoute,
  } as any)
const DashboardGuildsApplicationGuildIdKnowledgeBaseRoute =
  DashboardGuildsApplicationGuildIdKnowledgeBaseRouteImport.update({
    id: '/knowledge-base',
    path: '/knowledge-base',
    getParentRoute: () => DashboardGuildsApplicationGuildIdRoute,
  } as any)
const DashboardAdminUsersUserIdRoute =
  DashboardAdminUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => DashboardAdminUsersRoute,
  } as any)
const DashboardAdminCustomBotsApplicationIdRoute =
  DashboardAdminCustomBotsApplicationIdRouteImport.update({
    id: '/$applicationId',
    path: '/$applicationId',
    getParentRoute: () => DashboardAdminCustomBotsRoute,
  } as any)
const DashboardGuildsApplicationGuildIdTicketsIndexRoute =
  DashboardGuildsApplicationGuildIdTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => DashboardGuildsApplicationGuildIdRoute,
  } as any)
const DashboardGuildsApplicationGuildIdTicketsTicketIdRoute =
  DashboardGuildsApplicationGuildIdTicketsTicketIdRouteImport.update({
    id: '/tickets/$ticketId',
    path: '/tickets/$ticketId',
    getParentRoute: () => DashboardGuildsApplicationGuildIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dashboard/admin': typeof DashboardAdminRouteWithChildren
  '/dashboard/changelog': typeof DashboardChangelogRoute
  '/dashboard/user': typeof DashboardUserRoute
  '/invite/$token': typeof InviteTokenRoute
  '/transcripts/$transcriptId': typeof TranscriptsTranscriptIdRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/custom-bots': typeof DashboardAdminCustomBotsRouteWithChildren
  '/dashboard/admin/notifications': typeof DashboardAdminNotificationsRoute
  '/dashboard/admin/official-presets': typeof DashboardAdminOfficialPresetsRoute
  '/dashboard/admin/templates': typeof DashboardAdminTemplatesRouteWithChildren
  '/dashboard/admin/users': typeof DashboardAdminUsersRouteWithChildren
  '/dashboard/applications/$applicationId': typeof DashboardApplicationsApplicationIdRoute
  '/dashboard/checkout/return': typeof DashboardCheckoutReturnRoute
  '/dashboard/guilds/$applicationGuildId': typeof DashboardGuildsApplicationGuildIdRouteWithChildren
  '/dashboard/teams/$tenantId': typeof DashboardTeamsTenantIdRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/checkout/': typeof DashboardCheckoutIndexRoute
  '/dashboard/admin/custom-bots/$applicationId': typeof DashboardAdminCustomBotsApplicationIdRoute
  '/dashboard/admin/users/$userId': typeof DashboardAdminUsersUserIdRoute
  '/dashboard/guilds/$applicationGuildId/knowledge-base': typeof DashboardGuildsApplicationGuildIdKnowledgeBaseRoute
  '/dashboard/guilds/$applicationGuildId/permissions': typeof DashboardGuildsApplicationGuildIdPermissionsRoute
  '/dashboard/guilds/$applicationGuildId/threads-qa': typeof DashboardGuildsApplicationGuildIdThreadsQaRoute
  '/dashboard/admin/custom-bots/': typeof DashboardAdminCustomBotsIndexRoute
  '/dashboard/admin/templates/': typeof DashboardAdminTemplatesIndexRoute
  '/dashboard/admin/users/': typeof DashboardAdminUsersIndexRoute
  '/dashboard/guilds/$applicationGuildId/': typeof DashboardGuildsApplicationGuildIdIndexRoute
  '/dashboard/guilds/$applicationGuildId/tickets/$ticketId': typeof DashboardGuildsApplicationGuildIdTicketsTicketIdRoute
  '/dashboard/guilds/$applicationGuildId/tickets/': typeof DashboardGuildsApplicationGuildIdTicketsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard/changelog': typeof DashboardChangelogRoute
  '/dashboard/user': typeof DashboardUserRoute
  '/invite/$token': typeof InviteTokenRoute
  '/transcripts/$transcriptId': typeof TranscriptsTranscriptIdRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/admin/notifications': typeof DashboardAdminNotificationsRoute
  '/dashboard/admin/official-presets': typeof DashboardAdminOfficialPresetsRoute
  '/dashboard/applications/$applicationId': typeof DashboardApplicationsApplicationIdRoute
  '/dashboard/checkout/return': typeof DashboardCheckoutReturnRoute
  '/dashboard/teams/$tenantId': typeof DashboardTeamsTenantIdRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/checkout': typeof DashboardCheckoutIndexRoute
  '/dashboard/admin/custom-bots/$applicationId': typeof DashboardAdminCustomBotsApplicationIdRoute
  '/dashboard/admin/users/$userId': typeof DashboardAdminUsersUserIdRoute
  '/dashboard/guilds/$applicationGuildId/knowledge-base': typeof DashboardGuildsApplicationGuildIdKnowledgeBaseRoute
  '/dashboard/guilds/$applicationGuildId/permissions': typeof DashboardGuildsApplicationGuildIdPermissionsRoute
  '/dashboard/guilds/$applicationGuildId/threads-qa': typeof DashboardGuildsApplicationGuildIdThreadsQaRoute
  '/dashboard/admin/custom-bots': typeof DashboardAdminCustomBotsIndexRoute
  '/dashboard/admin/templates': typeof DashboardAdminTemplatesIndexRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersIndexRoute
  '/dashboard/guilds/$applicationGuildId': typeof DashboardGuildsApplicationGuildIdIndexRoute
  '/dashboard/guilds/$applicationGuildId/tickets/$ticketId': typeof DashboardGuildsApplicationGuildIdTicketsTicketIdRoute
  '/dashboard/guilds/$applicationGuildId/tickets': typeof DashboardGuildsApplicationGuildIdTicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dashboard/admin': typeof DashboardAdminRouteWithChildren
  '/dashboard/changelog': typeof DashboardChangelogRoute
  '/dashboard/user': typeof DashboardUserRoute
  '/invite/$token': typeof InviteTokenRoute
  '/transcripts/$transcriptId': typeof TranscriptsTranscriptIdRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/custom-bots': typeof DashboardAdminCustomBotsRouteWithChildren
  '/dashboard/admin/notifications': typeof DashboardAdminNotificationsRoute
  '/dashboard/admin/official-presets': typeof DashboardAdminOfficialPresetsRoute
  '/dashboard/admin/templates': typeof DashboardAdminTemplatesRouteWithChildren
  '/dashboard/admin/users': typeof DashboardAdminUsersRouteWithChildren
  '/dashboard/applications/$applicationId': typeof DashboardApplicationsApplicationIdRoute
  '/dashboard/checkout/return': typeof DashboardCheckoutReturnRoute
  '/dashboard/guilds/$applicationGuildId': typeof DashboardGuildsApplicationGuildIdRouteWithChildren
  '/dashboard/teams/$tenantId': typeof DashboardTeamsTenantIdRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/checkout/': typeof DashboardCheckoutIndexRoute
  '/dashboard/admin/custom-bots/$applicationId': typeof DashboardAdminCustomBotsApplicationIdRoute
  '/dashboard/admin/users/$userId': typeof DashboardAdminUsersUserIdRoute
  '/dashboard/guilds/$applicationGuildId/knowledge-base': typeof DashboardGuildsApplicationGuildIdKnowledgeBaseRoute
  '/dashboard/guilds/$applicationGuildId/permissions': typeof DashboardGuildsApplicationGuildIdPermissionsRoute
  '/dashboard/guilds/$applicationGuildId/threads-qa': typeof DashboardGuildsApplicationGuildIdThreadsQaRoute
  '/dashboard/admin/custom-bots/': typeof DashboardAdminCustomBotsIndexRoute
  '/dashboard/admin/templates/': typeof DashboardAdminTemplatesIndexRoute
  '/dashboard/admin/users/': typeof DashboardAdminUsersIndexRoute
  '/dashboard/guilds/$applicationGuildId/': typeof DashboardGuildsApplicationGuildIdIndexRoute
  '/dashboard/guilds/$applicationGuildId/tickets/$ticketId': typeof DashboardGuildsApplicationGuildIdTicketsTicketIdRoute
  '/dashboard/guilds/$applicationGuildId/tickets/': typeof DashboardGuildsApplicationGuildIdTicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/dashboard/admin'
    | '/dashboard/changelog'
    | '/dashboard/user'
    | '/invite/$token'
    | '/transcripts/$transcriptId'
    | '/dashboard/'
    | '/dashboard/admin/custom-bots'
    | '/dashboard/admin/notifications'
    | '/dashboard/admin/official-presets'
    | '/dashboard/admin/templates'
    | '/dashboard/admin/users'
    | '/dashboard/applications/$applicationId'
    | '/dashboard/checkout/return'
    | '/dashboard/guilds/$applicationGuildId'
    | '/dashboard/teams/$tenantId'
    | '/dashboard/admin/'
    | '/dashboard/checkout/'
    | '/dashboard/admin/custom-bots/$applicationId'
    | '/dashboard/admin/users/$userId'
    | '/dashboard/guilds/$applicationGuildId/knowledge-base'
    | '/dashboard/guilds/$applicationGuildId/permissions'
    | '/dashboard/guilds/$applicationGuildId/threads-qa'
    | '/dashboard/admin/custom-bots/'
    | '/dashboard/admin/templates/'
    | '/dashboard/admin/users/'
    | '/dashboard/guilds/$applicationGuildId/'
    | '/dashboard/guilds/$applicationGuildId/tickets/$ticketId'
    | '/dashboard/guilds/$applicationGuildId/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard/changelog'
    | '/dashboard/user'
    | '/invite/$token'
    | '/transcripts/$transcriptId'
    | '/dashboard'
    | '/dashboard/admin/notifications'
    | '/dashboard/admin/official-presets'
    | '/dashboard/applications/$applicationId'
    | '/dashboard/checkout/return'
    | '/dashboard/teams/$tenantId'
    | '/dashboard/admin'
    | '/dashboard/checkout'
    | '/dashboard/admin/custom-bots/$applicationId'
    | '/dashboard/admin/users/$userId'
    | '/dashboard/guilds/$applicationGuildId/knowledge-base'
    | '/dashboard/guilds/$applicationGuildId/permissions'
    | '/dashboard/guilds/$applicationGuildId/threads-qa'
    | '/dashboard/admin/custom-bots'
    | '/dashboard/admin/templates'
    | '/dashboard/admin/users'
    | '/dashboard/guilds/$applicationGuildId'
    | '/dashboard/guilds/$applicationGuildId/tickets/$ticketId'
    | '/dashboard/guilds/$applicationGuildId/tickets'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/dashboard/admin'
    | '/dashboard/changelog'
    | '/dashboard/user'
    | '/invite/$token'
    | '/transcripts/$transcriptId'
    | '/dashboard/'
    | '/dashboard/admin/custom-bots'
    | '/dashboard/admin/notifications'
    | '/dashboard/admin/official-presets'
    | '/dashboard/admin/templates'
    | '/dashboard/admin/users'
    | '/dashboard/applications/$applicationId'
    | '/dashboard/checkout/return'
    | '/dashboard/guilds/$applicationGuildId'
    | '/dashboard/teams/$tenantId'
    | '/dashboard/admin/'
    | '/dashboard/checkout/'
    | '/dashboard/admin/custom-bots/$applicationId'
    | '/dashboard/admin/users/$userId'
    | '/dashboard/guilds/$applicationGuildId/knowledge-base'
    | '/dashboard/guilds/$applicationGuildId/permissions'
    | '/dashboard/guilds/$applicationGuildId/threads-qa'
    | '/dashboard/admin/custom-bots/'
    | '/dashboard/admin/templates/'
    | '/dashboard/admin/users/'
    | '/dashboard/guilds/$applicationGuildId/'
    | '/dashboard/guilds/$applicationGuildId/tickets/$ticketId'
    | '/dashboard/guilds/$applicationGuildId/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  InviteTokenRoute: typeof InviteTokenRoute
  TranscriptsTranscriptIdRoute: typeof TranscriptsTranscriptIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/transcripts/$transcriptId': {
      id: '/transcripts/$transcriptId'
      path: '/transcripts/$transcriptId'
      fullPath: '/transcripts/$transcriptId'
      preLoaderRoute: typeof TranscriptsTranscriptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/user': {
      id: '/dashboard/user'
      path: '/user'
      fullPath: '/dashboard/user'
      preLoaderRoute: typeof DashboardUserRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/changelog': {
      id: '/dashboard/changelog'
      path: '/changelog'
      fullPath: '/dashboard/changelog'
      preLoaderRoute: typeof DashboardChangelogRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin': {
      id: '/dashboard/admin'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardAdminRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/checkout/': {
      id: '/dashboard/checkout/'
      path: '/checkout'
      fullPath: '/dashboard/checkout/'
      preLoaderRoute: typeof DashboardCheckoutIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/teams/$tenantId': {
      id: '/dashboard/teams/$tenantId'
      path: '/teams/$tenantId'
      fullPath: '/dashboard/teams/$tenantId'
      preLoaderRoute: typeof DashboardTeamsTenantIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/guilds/$applicationGuildId': {
      id: '/dashboard/guilds/$applicationGuildId'
      path: '/guilds/$applicationGuildId'
      fullPath: '/dashboard/guilds/$applicationGuildId'
      preLoaderRoute: typeof DashboardGuildsApplicationGuildIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/checkout/return': {
      id: '/dashboard/checkout/return'
      path: '/checkout/return'
      fullPath: '/dashboard/checkout/return'
      preLoaderRoute: typeof DashboardCheckoutReturnRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/applications/$applicationId': {
      id: '/dashboard/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/dashboard/applications/$applicationId'
      preLoaderRoute: typeof DashboardApplicationsApplicationIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/users': {
      id: '/dashboard/admin/users'
      path: '/users'
      fullPath: '/dashboard/admin/users'
      preLoaderRoute: typeof DashboardAdminUsersRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/templates': {
      id: '/dashboard/admin/templates'
      path: '/templates'
      fullPath: '/dashboard/admin/templates'
      preLoaderRoute: typeof DashboardAdminTemplatesRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/official-presets': {
      id: '/dashboard/admin/official-presets'
      path: '/official-presets'
      fullPath: '/dashboard/admin/official-presets'
      preLoaderRoute: typeof DashboardAdminOfficialPresetsRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/notifications': {
      id: '/dashboard/admin/notifications'
      path: '/notifications'
      fullPath: '/dashboard/admin/notifications'
      preLoaderRoute: typeof DashboardAdminNotificationsRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/admin/custom-bots': {
      id: '/dashboard/admin/custom-bots'
      path: '/custom-bots'
      fullPath: '/dashboard/admin/custom-bots'
      preLoaderRoute: typeof DashboardAdminCustomBotsRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/guilds/$applicationGuildId/': {
      id: '/dashboard/guilds/$applicationGuildId/'
      path: '/'
      fullPath: '/dashboard/guilds/$applicationGuildId/'
      preLoaderRoute: typeof DashboardGuildsApplicationGuildIdIndexRouteImport
      parentRoute: typeof DashboardGuildsApplicationGuildIdRoute
    }
    '/dashboard/admin/users/': {
      id: '/dashboard/admin/users/'
      path: '/'
      fullPath: '/dashboard/admin/users/'
      preLoaderRoute: typeof DashboardAdminUsersIndexRouteImport
      parentRoute: typeof DashboardAdminUsersRoute
    }
    '/dashboard/admin/templates/': {
      id: '/dashboard/admin/templates/'
      path: '/'
      fullPath: '/dashboard/admin/templates/'
      preLoaderRoute: typeof DashboardAdminTemplatesIndexRouteImport
      parentRoute: typeof DashboardAdminTemplatesRoute
    }
    '/dashboard/admin/custom-bots/': {
      id: '/dashboard/admin/custom-bots/'
      path: '/'
      fullPath: '/dashboard/admin/custom-bots/'
      preLoaderRoute: typeof DashboardAdminCustomBotsIndexRouteImport
      parentRoute: typeof DashboardAdminCustomBotsRoute
    }
    '/dashboard/guilds/$applicationGuildId/threads-qa': {
      id: '/dashboard/guilds/$applicationGuildId/threads-qa'
      path: '/threads-qa'
      fullPath: '/dashboard/guilds/$applicationGuildId/threads-qa'
      preLoaderRoute: typeof DashboardGuildsApplicationGuildIdThreadsQaRouteImport
      parentRoute: typeof DashboardGuildsApplicationGuildIdRoute
    }
    '/dashboard/guilds/$applicationGuildId/permissions': {
      id: '/dashboard/guilds/$applicationGuildId/permissions'
      path: '/permissions'
      fullPath: '/dashboard/guilds/$applicationGuildId/permissions'
      preLoaderRoute: typeof DashboardGuildsApplicationGuildIdPermissionsRouteImport
      parentRoute: typeof DashboardGuildsApplicationGuildIdRoute
    }
    '/dashboard/guilds/$applicationGuildId/knowledge-base': {
      id: '/dashboard/guilds/$applicationGuildId/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/dashboard/guilds/$applicationGuildId/knowledge-base'
      preLoaderRoute: typeof DashboardGuildsApplicationGuildIdKnowledgeBaseRouteImport
      parentRoute: typeof DashboardGuildsApplicationGuildIdRoute
    }
    '/dashboard/admin/users/$userId': {
      id: '/dashboard/admin/users/$userId'
      path: '/$userId'
      fullPath: '/dashboard/admin/users/$userId'
      preLoaderRoute: typeof DashboardAdminUsersUserIdRouteImport
      parentRoute: typeof DashboardAdminUsersRoute
    }
    '/dashboard/admin/custom-bots/$applicationId': {
      id: '/dashboard/admin/custom-bots/$applicationId'
      path: '/$applicationId'
      fullPath: '/dashboard/admin/custom-bots/$applicationId'
      preLoaderRoute: typeof DashboardAdminCustomBotsApplicationIdRouteImport
      parentRoute: typeof DashboardAdminCustomBotsRoute
    }
    '/dashboard/guilds/$applicationGuildId/tickets/': {
      id: '/dashboard/guilds/$applicationGuildId/tickets/'
      path: '/tickets'
      fullPath: '/dashboard/guilds/$applicationGuildId/tickets/'
      preLoaderRoute: typeof DashboardGuildsApplicationGuildIdTicketsIndexRouteImport
      parentRoute: typeof DashboardGuildsApplicationGuildIdRoute
    }
    '/dashboard/guilds/$applicationGuildId/tickets/$ticketId': {
      id: '/dashboard/guilds/$applicationGuildId/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/dashboard/guilds/$applicationGuildId/tickets/$ticketId'
      preLoaderRoute: typeof DashboardGuildsApplicationGuildIdTicketsTicketIdRouteImport
      parentRoute: typeof DashboardGuildsApplicationGuildIdRoute
    }
  }
}

interface DashboardAdminCustomBotsRouteChildren {
  DashboardAdminCustomBotsApplicationIdRoute: typeof DashboardAdminCustomBotsApplicationIdRoute
  DashboardAdminCustomBotsIndexRoute: typeof DashboardAdminCustomBotsIndexRoute
}

const DashboardAdminCustomBotsRouteChildren: DashboardAdminCustomBotsRouteChildren =
  {
    DashboardAdminCustomBotsApplicationIdRoute:
      DashboardAdminCustomBotsApplicationIdRoute,
    DashboardAdminCustomBotsIndexRoute: DashboardAdminCustomBotsIndexRoute,
  }

const DashboardAdminCustomBotsRouteWithChildren =
  DashboardAdminCustomBotsRoute._addFileChildren(
    DashboardAdminCustomBotsRouteChildren,
  )

interface DashboardAdminTemplatesRouteChildren {
  DashboardAdminTemplatesIndexRoute: typeof DashboardAdminTemplatesIndexRoute
}

const DashboardAdminTemplatesRouteChildren: DashboardAdminTemplatesRouteChildren =
  {
    DashboardAdminTemplatesIndexRoute: DashboardAdminTemplatesIndexRoute,
  }

const DashboardAdminTemplatesRouteWithChildren =
  DashboardAdminTemplatesRoute._addFileChildren(
    DashboardAdminTemplatesRouteChildren,
  )

interface DashboardAdminUsersRouteChildren {
  DashboardAdminUsersUserIdRoute: typeof DashboardAdminUsersUserIdRoute
  DashboardAdminUsersIndexRoute: typeof DashboardAdminUsersIndexRoute
}

const DashboardAdminUsersRouteChildren: DashboardAdminUsersRouteChildren = {
  DashboardAdminUsersUserIdRoute: DashboardAdminUsersUserIdRoute,
  DashboardAdminUsersIndexRoute: DashboardAdminUsersIndexRoute,
}

const DashboardAdminUsersRouteWithChildren =
  DashboardAdminUsersRoute._addFileChildren(DashboardAdminUsersRouteChildren)

interface DashboardAdminRouteChildren {
  DashboardAdminCustomBotsRoute: typeof DashboardAdminCustomBotsRouteWithChildren
  DashboardAdminNotificationsRoute: typeof DashboardAdminNotificationsRoute
  DashboardAdminOfficialPresetsRoute: typeof DashboardAdminOfficialPresetsRoute
  DashboardAdminTemplatesRoute: typeof DashboardAdminTemplatesRouteWithChildren
  DashboardAdminUsersRoute: typeof DashboardAdminUsersRouteWithChildren
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
}

const DashboardAdminRouteChildren: DashboardAdminRouteChildren = {
  DashboardAdminCustomBotsRoute: DashboardAdminCustomBotsRouteWithChildren,
  DashboardAdminNotificationsRoute: DashboardAdminNotificationsRoute,
  DashboardAdminOfficialPresetsRoute: DashboardAdminOfficialPresetsRoute,
  DashboardAdminTemplatesRoute: DashboardAdminTemplatesRouteWithChildren,
  DashboardAdminUsersRoute: DashboardAdminUsersRouteWithChildren,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
}

const DashboardAdminRouteWithChildren = DashboardAdminRoute._addFileChildren(
  DashboardAdminRouteChildren,
)

interface DashboardGuildsApplicationGuildIdRouteChildren {
  DashboardGuildsApplicationGuildIdKnowledgeBaseRoute: typeof DashboardGuildsApplicationGuildIdKnowledgeBaseRoute
  DashboardGuildsApplicationGuildIdPermissionsRoute: typeof DashboardGuildsApplicationGuildIdPermissionsRoute
  DashboardGuildsApplicationGuildIdThreadsQaRoute: typeof DashboardGuildsApplicationGuildIdThreadsQaRoute
  DashboardGuildsApplicationGuildIdIndexRoute: typeof DashboardGuildsApplicationGuildIdIndexRoute
  DashboardGuildsApplicationGuildIdTicketsTicketIdRoute: typeof DashboardGuildsApplicationGuildIdTicketsTicketIdRoute
  DashboardGuildsApplicationGuildIdTicketsIndexRoute: typeof DashboardGuildsApplicationGuildIdTicketsIndexRoute
}

const DashboardGuildsApplicationGuildIdRouteChildren: DashboardGuildsApplicationGuildIdRouteChildren =
  {
    DashboardGuildsApplicationGuildIdKnowledgeBaseRoute:
      DashboardGuildsApplicationGuildIdKnowledgeBaseRoute,
    DashboardGuildsApplicationGuildIdPermissionsRoute:
      DashboardGuildsApplicationGuildIdPermissionsRoute,
    DashboardGuildsApplicationGuildIdThreadsQaRoute:
      DashboardGuildsApplicationGuildIdThreadsQaRoute,
    DashboardGuildsApplicationGuildIdIndexRoute:
      DashboardGuildsApplicationGuildIdIndexRoute,
    DashboardGuildsApplicationGuildIdTicketsTicketIdRoute:
      DashboardGuildsApplicationGuildIdTicketsTicketIdRoute,
    DashboardGuildsApplicationGuildIdTicketsIndexRoute:
      DashboardGuildsApplicationGuildIdTicketsIndexRoute,
  }

const DashboardGuildsApplicationGuildIdRouteWithChildren =
  DashboardGuildsApplicationGuildIdRoute._addFileChildren(
    DashboardGuildsApplicationGuildIdRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardAdminRoute: typeof DashboardAdminRouteWithChildren
  DashboardChangelogRoute: typeof DashboardChangelogRoute
  DashboardUserRoute: typeof DashboardUserRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardApplicationsApplicationIdRoute: typeof DashboardApplicationsApplicationIdRoute
  DashboardCheckoutReturnRoute: typeof DashboardCheckoutReturnRoute
  DashboardGuildsApplicationGuildIdRoute: typeof DashboardGuildsApplicationGuildIdRouteWithChildren
  DashboardTeamsTenantIdRoute: typeof DashboardTeamsTenantIdRoute
  DashboardCheckoutIndexRoute: typeof DashboardCheckoutIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAdminRoute: DashboardAdminRouteWithChildren,
  DashboardChangelogRoute: DashboardChangelogRoute,
  DashboardUserRoute: DashboardUserRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardApplicationsApplicationIdRoute:
    DashboardApplicationsApplicationIdRoute,
  DashboardCheckoutReturnRoute: DashboardCheckoutReturnRoute,
  DashboardGuildsApplicationGuildIdRoute:
    DashboardGuildsApplicationGuildIdRouteWithChildren,
  DashboardTeamsTenantIdRoute: DashboardTeamsTenantIdRoute,
  DashboardCheckoutIndexRoute: DashboardCheckoutIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  InviteTokenRoute: InviteTokenRoute,
  TranscriptsTranscriptIdRoute: TranscriptsTranscriptIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
